export const INSPECTION_SECTIONS = [
  ["vehicle_id_tampering", "Vehicle ID & Tampering"],
  ["front_structure", "Front Structure & Engine Bay"],
  ["main_body_structure", "Main Body Structure"],
  ["rear_underbody", "Rear & Underbody Structure"],
  ["fire_flood", "Fire & Flood Check"],
  ["engine_system", "Engine System"],
  ["transmission_system", "Transmission & Drivetrain"],
  ["cooling_system", "Cooling System"],
  ["fuel_system", "Fuel & Exhaust System"],
  ["suspension_system", "Suspension & Steering"],
  ["brake_system", "Brake System"],
  ["tyres_wheels", "Tyres & Wheels"],
  ["electrical_system", "Electrical System"],
  ["interior_system", "Interior System"],
  ["safety_electronic_control", "Safety & Electronic Control"],
  ["front_body", "Front Body"],
  ["left_body", "Left Body"],
  ["right_body", "Right Body"],
  ["rear_body", "Rear Body"],
  ["upper_body_glass", "Upper Body & Glass"],
];

export function getInspectionSections(report = {}) {
  return INSPECTION_SECTIONS.map(([key, title]) => ({
    key,
    title,
    items: Array.isArray(report[key]) ? report[key] : [],
  }));
}

export function getInspectionTotals(report = {}) {
  const items = getInspectionSections(report).flatMap((section) => section.items);
  return {
    passed: report.pass ?? items.filter((item) => item?.status === "yes").length,
    identified: report.identified ?? items.filter((item) => item?.status === "no").length,
    total: report.total_checkpoints ?? report.total_points ?? (items.length || 160),
  };
}

export function getInspectionGrades(report = {}) {
  return [
    ["exterior", "Exterior"],
    ["interior", "Interior & Electrical"],
    ["powertrain", "Powertrain"],
    ["structure", "Structure & Safety"],
  ].map(([key, label]) => ({
    key,
    label,
    value: report[`${key}_grade`] ??
      report.overview?.find((item) => item.key === key)?.rating ??
      (key === "structure" ? report.history_grade : undefined) ?? "-",
  }));
}

// The API may include each photo in both `media` and `photos`.
export function getFindingMedia(item = {}) {
  const ids = new Set();
  const urls = new Set();
  return [item.media, item.photos, item.images]
    .filter(Array.isArray)
    .flat()
    .map((entry) => typeof entry === "string" ? { url: entry } : entry)
    .filter(Boolean)
    .map((entry) => ({ ...entry, url: entry.url || entry.api_url }))
    .filter((entry) => {
      const id = entry.image_id == null ? null : String(entry.image_id);
      if (!entry.url || urls.has(entry.url) || (id && ids.has(id))) return false;
      urls.add(entry.url);
      if (id) ids.add(id);
      return true;
    });
}
